module.exports = __webpack_public_path__ + "media/images/sp/page_common/keywords/keyword_osharenahouse-818a9b6c7a42e840cf74b11ec2088e9b.jpg";